import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Impressum - Adloc</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-[#FAF3E0] py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="mb-8"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Button>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>

            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">Angaben gemäß § 5 TMG</h2>
                <p className="leading-relaxed">
                  Atilla Ciftcioglu<br />
                  Hüttenstraße 100<br />
                  56170 Bendorf
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">Vertreten durch</h2>
                <p>Atilla Ciftcioglu</p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">Kontakt</h2>
                <p>
                  E-Mail:{' '}
                  <a href="mailto:kontakt@adloc.io" className="text-[#2835F7] hover:underline">
                    kontakt@adloc.io
                  </a>
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">Umsatzsteuer-ID</h2>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:<br />
                  DE316853316
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">EU-Streitschlichtung</h2>
                <p className="leading-relaxed">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                  <a 
                    href="https://ec.europa.eu/consumers/odr/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#2835F7] hover:underline"
                  >
                    https://ec.europa.eu/consumers/odr/
                  </a>
                  .<br />
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">
                  Verbraucherstreitbeilegung / Universalschlichtungsstelle
                </h2>
                <p className="leading-relaxed">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Impressum;